//#region src/location_state.ts
var LocationState = /* @__PURE__ */ function(LocationState) {
	LocationState[LocationState["Draft"] = 0] = "Draft";
	LocationState[LocationState["Live"] = 1] = "Live";
	LocationState[LocationState["BiteOnly"] = 2] = "BiteOnly";
	LocationState[LocationState["Churned"] = 3] = "Churned";
	return LocationState;
}(LocationState || {});
//#endregion
export { LocationState };

//# sourceMappingURL=location_state.js.map